/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_d12f1362{overflow:auto}"}]);
export const root = "root_d12f1362";